module.exports = __webpack_public_path__ + "img/advanced-image-first.9dd3f136.jpg";